module.exports = __webpack_public_path__ + "static/allianz-bg-7ac8d18c27e29981433989f3e76a3f7b.png";